export const initialGreetingCard =
  'https://res.cloudinary.com/gift-card-granny/image/upload/w_270,f_auto/v1670514490/PG/corp_predesign_greeting_cards/thinking-of-you_iardqn';

export const anonymousName = 'Anonymous';
